import { create } from "zustand";

export interface WhatsappModalState {
  isOpen: boolean;
  groupId: number | null; // mandatory
  companyId: number | null;
  contactId: number | null; // mandatory
  communicationType: number | null;
  entityId: string | null;
  sendQuotation: boolean;
  open(
    groupId: number | null,
    companyId: number,
    contactId: number,
    communicationType: number | null,
    entityId: string | null,
    sendQuotation: boolean,
  ): void;
  close(): void;
}

export const useWhatsappModalStore = create<WhatsappModalState>((set) => {
  return {
    isOpen: false,
    groupId: null,
    companyId: null,
    contactId: null,
    communicationType: null,
    entityId: null,
    sendQuotation: false,
    open: (
      groupId: number | null,
      companyId: number,
      contactId: number,
      communicationType: number | null,
      entityId: string | null,
      sendQuotation: boolean,
    ) =>
      set(() => ({
        isOpen: true,
        groupId,
        companyId,
        contactId,
        communicationType,
        entityId,
        sendQuotation,
      })),

    close: () =>
      set(() => ({
        isOpen: false,
        groupId: null,
        companyId: null,
        contactId: null,
        communicationType: null,
        entityId: null,
        sendQuotation: false,
      })),
  };
});
